function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1940(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24.69,
    height: 9.03,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.12875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.345,
    y: 4.515
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.03,
    width: 24.69,
    height: 22.54,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.345,
    y: 20.299999999999997
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 31.57,
    width: 24.69,
    height: 29.16,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.938000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.345,
    y: 46.15
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 60.73,
    width: 24.69,
    height: 35.88,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.7433333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.345,
    y: 78.67
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 96.61,
    width: 24.69,
    height: 36.25,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.938000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.345,
    y: 114.735
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 132.87,
    width: 24.69,
    height: 37.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.345,
    y: 151.725
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 170.58,
    width: 24.69,
    height: 39.6,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.345,
    y: 190.38000000000002
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 210.18,
    width: 24.69,
    height: 43.25,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.938000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.345,
    y: 231.805
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 253.43,
    width: 24.69,
    height: 48.79,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.527142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.345,
    y: 277.825
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 302.22,
    width: 24.69,
    height: 49.53,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.527142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.345,
    y: 326.985
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 351.75,
    width: 24.69,
    height: 52.23,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.345,
    y: 377.865
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 403.98,
    width: 24.69,
    height: 54.73,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.08625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.345,
    y: 431.345
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 458.71,
    width: 24.69,
    height: 54.86,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.938000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.345,
    y: 486.14
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 513.57,
    width: 24.69,
    height: 59.99,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4690000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.345,
    y: 543.565
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 573.57,
    width: 24.69,
    height: 61.15,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.08625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.345,
    y: 604.1450000000001
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 634.72,
    width: 24.69,
    height: 65.28,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.08625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.345,
    y: 667.36
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.69,
    y: 0,
    width: 36.93,
    height: 43.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.155
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.155,
    y: 21.985
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.62,
    y: 0,
    width: 36.99,
    height: 43.97,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.62375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.115,
    y: 21.985
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.61,
    y: 0,
    width: 37.47,
    height: 43.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.352857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 117.345,
    y: 21.985
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.08,
    y: 0,
    width: 38.24,
    height: 43.97,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.4628571428571435
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 155.20000000000002,
    y: 21.985
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174.32,
    y: 0,
    width: 38.29,
    height: 43.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.78625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 193.465,
    y: 21.985
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.61,
    y: 0,
    width: 38.3,
    height: 43.97,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.7875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 231.76000000000002,
    y: 21.985
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 250.91,
    y: 0,
    width: 38.37,
    height: 43.97,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.79625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 270.09499999999997,
    y: 21.985
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 289.28,
    y: 0,
    width: 38.48,
    height: 43.97,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.497142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 308.52,
    y: 21.985
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.76,
    y: 0,
    width: 39.12,
    height: 43.97,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 347.32,
    y: 21.985
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 366.87,
    y: 0,
    width: 42.32,
    height: 43.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.232
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 388.03000000000003,
    y: 21.985
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 409.19,
    y: 0,
    width: 42.39,
    height: 43.97,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.065
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 430.385,
    y: 21.985
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 451.58,
    y: 0,
    width: 43.5,
    height: 43.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 473.33,
    y: 21.985
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 495.08,
    y: 0,
    width: 46.98,
    height: 43.97,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.794
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 518.5699999999999,
    y: 21.985
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 542.06,
    y: 0,
    width: 49.71,
    height: 43.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.281428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 566.915,
    y: 21.985
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 591.77,
    y: 0,
    width: 54.11,
    height: 43.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.49625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 618.8249999999999,
    y: 21.985
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 645.88,
    y: 0,
    width: 54.12,
    height: 43.97,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.397
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 672.9399999999999,
    y: 21.985
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.69,
    y: 43.97,
    width: 59.31,
    height: 45.87,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.345,
    y: 66.905
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.69,
    y: 89.84,
    width: 59.31,
    height: 46.02,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.670000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.345,
    y: 112.85000000000001
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.69,
    y: 135.86,
    width: 59.31,
    height: 46.19,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.77375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.345,
    y: 158.955
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.69,
    y: 182.05,
    width: 59.31,
    height: 47.41,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.901666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.345,
    y: 205.755
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.69,
    y: 229.45,
    width: 59.31,
    height: 47.67,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.95875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.345,
    y: 253.285
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.69,
    y: 277.13,
    width: 59.31,
    height: 49.07,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.01
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.345,
    y: 301.665
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.69,
    y: 326.19,
    width: 59.31,
    height: 52.33,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.360833333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.345,
    y: 352.355
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.69,
    y: 378.52,
    width: 59.31,
    height: 52.68,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.8533333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.345,
    y: 404.85999999999996
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.69,
    y: 431.2,
    width: 59.31,
    height: 55.43,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.918571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.345,
    y: 458.91499999999996
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.69,
    y: 486.64,
    width: 59.31,
    height: 62.41,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.885
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.345,
    y: 517.845
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.69,
    y: 549.05,
    width: 59.31,
    height: 75,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.931
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.345,
    y: 586.55
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.69,
    y: 624.04,
    width: 59.31,
    height: 75.96,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.41375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.345,
    y: 662.02
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 43.97,
    width: 65.13,
    height: 79.21,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.920909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.565,
    y: 83.57499999999999
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.13,
    y: 43.97,
    width: 65.34,
    height: 79.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 181.8,
    y: 83.57499999999999
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.47,
    y: 43.97,
    width: 68.68,
    height: 79.21,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.811428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 248.81,
    y: 83.57499999999999
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 283.15,
    y: 43.97,
    width: 70.67,
    height: 79.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.067
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.48499999999996,
    y: 83.57499999999999
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 353.82,
    y: 43.97,
    width: 74.74,
    height: 79.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.456666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 391.19,
    y: 83.57499999999999
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 428.56,
    y: 43.97,
    width: 75.9,
    height: 79.21,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.4875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 466.51,
    y: 83.57499999999999
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 504.46,
    y: 43.97,
    width: 95.86,
    height: 79.21,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.315714285714284
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 552.39,
    y: 83.57499999999999
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 600.32,
    y: 43.97,
    width: 99.68,
    height: 79.21,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.201666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 650.1600000000001,
    y: 83.57499999999999
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 123.18,
    width: 100.72,
    height: 104.93,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.786666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 134.36,
    y: 175.645
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 228.11,
    width: 100.72,
    height: 122.53,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.59
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 134.36,
    y: 289.375
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 350.64,
    width: 100.72,
    height: 167.44,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.786666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 134.36,
    y: 434.36
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 518.08,
    width: 100.72,
    height: 181.92,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.786666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 134.36,
    y: 609.0400000000001
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 184.71,
    y: 123.18,
    width: 118.04,
    height: 193.09,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.730909090909092
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 243.73000000000002,
    y: 219.72500000000002
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 302.75,
    y: 123.18,
    width: 150.49,
    height: 193.09,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 37.6225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 377.995,
    y: 219.72500000000002
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453.24,
    y: 123.18,
    width: 246.76,
    height: 193.09,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 32.181666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 576.62,
    y: 219.72500000000002
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 184.71,
    y: 316.27,
    width: 283.61,
    height: 170.81,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 34.162
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 326.515,
    y: 401.67499999999995
  }, "\n        Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 184.71,
    y: 487.08,
    width: 283.61,
    height: 212.92,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 26.615
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 326.515,
    y: 593.54
  }, "\n        New_York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.32,
    y: 316.27,
    width: 231.68,
    height: 383.73,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 46.336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 584.16,
    y: 508.135
  }, "\n        Kings\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1940);
export default __webpack_public_path__ + "static/media/1940.0e7c7d6d8cf96d386b275f85a0ae2199.svg";
export { ForwardRef as ReactComponent };